var namespace = { exports: {} };
export {
  namespace as __module
};
//# sourceMappingURL=namespace.js.map
